<section id="standardDeployment" class=" d-flex align-items-center offering z-depth-5 section ">
      <div class="container" data-aos="fade-up" id="grid">

            <div class="section-title">
                  <h2>Standard Deployment Approach</h2>
            </div>

            <div class="row" data-aos="zoom-in" data-aos-delay="150">
                  <div class="col">
                        <div class="card justify-content-center">
                              <div class="row" data-aos="zoom-in" data-aos-delay="150">
                                    <div class="col-lg-11 p-3 mx-5">
                                          <div class="circle-container">
                                                <div class="outer-circle">
                                                      <div class="inner-circle">
                                                            <div class="inner-circle-content">
                                                                  <span class="txtColor">01</span>
                                                                  <span class="txtcenter mt-2 label text-uppercase">Client
                                                                        Information</span>

                                                            </div>
                                                      </div>
                                                </div>

                                                <div class="outer-circle">
                                                      <div class="inner-circle">
                                                            <div class="inner-circle-content">
                                                                  <span class="txtColor">02</span>
                                                                  <span class="txtcenter mt-2 label text-uppercase">System
                                                                        Connectivity</span>
                                                            </div>
                                                      </div>
                                                </div>

                                                <div class="outer-circle">
                                                      <div class="inner-circle">
                                                            <div class="inner-circle-content">
                                                                  <span class="txtColor">03</span>
                                                                  <span class="txtcenter mt-2 label text-uppercase">Transport
                                                                        Movement</span>


                                                            </div>
                                                      </div>
                                                </div>
                                                <div class="outer-circle">
                                                      <div class="inner-circle">
                                                            <div class="inner-circle-content">
                                                                  <span class="txtColor">04</span>
                                                                  <span class="txtcenter mt-2 label text-uppercase">Gather
                                                                        Inputs</span>


                                                            </div>
                                                      </div>
                                                </div>
                                                <div class="outer-circle">
                                                      <div class="inner-circle">
                                                            <div class="inner-circle-content">
                                                                  <span class="txtColor">05</span>
                                                                  <span class="txtcenter mt-2 label text-uppercase">Generate
                                                                        Insights</span>


                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>

           
            <div class="row justify-content-center ">

                  <p class="mod-singular-pager">
                        <a mdbPageScroll href="#offering"
                              class="mod-singular-prev js-singular-prev scrollto z-depth-5 scrollarrow"
                              mdbTooltip="Our Offerings" placement="right"></a>

                  </p>
            </div>
      </div>
</section>